import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Orders from "./pages/Orders";
import CreateKit from "./flows/createKit/CreateKit";
import Account from "./pages/Account";
import Create from "./flows/createTeam/Create";
import BuildKit from "./flows/buildKit/BuildKit";
import TeamPortal from "./pages/TeamPortal";
import OrderKit from "./flows/orderKit/OrderKit";
import AcceptInvite from "./pages/AcceptInvite";
import Profile from "./pages/Profile";
import OrderSuccess from "./flows/orderKit/OrderSuccess";

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="team/:teamId" element={<TeamPortal />} />
        <Route path="create-kit" element={<CreateKit />} />
        <Route path="build" element={<BuildKit />} />
        <Route path="order" element={<OrderKit />} />
        <Route path="order-success" element={<OrderSuccess />} />
        <Route path="create" element={<Create />} />
        <Route element={<Layout />}>
          <Route path="orders" element={<Orders />} />
          <Route path="account" element={<Account />} />
          <Route path="accept-invite" element={<AcceptInvite />} />
          <Route path="profile" element={<Profile />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default App;